export class SchemaRegistryAuthConfig {
    'type';
    'credentialsSecretArn';
    'tlsSecretArn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "SchemaRegistryAuthType",
            "format": ""
        },
        {
            "name": "credentialsSecretArn",
            "baseName": "credentialsSecretArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "tlsSecretArn",
            "baseName": "tlsSecretArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistryAuthConfig.attributeTypeMap;
    }
    constructor() {
    }
}
